import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { ButtonLoading, FormInput } from "go-form";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { adminApi } from "../../../../../../../services/Api/Admin/adminApi";
import { UserApi } from "../../../../../../../services/Api/types";

interface Props {
	user?: UserApi;
}

const UserForm = (props: Props) => {
	const form = useForm<UserApi>({
		criteriaMode: "all",
		defaultValues: props.user,
	});
	const {
		register,
		handleSubmit,
		formState: { errors },
		setError,
		reset,
	} = form;
	const [loading, setLoading] = useState(false);
	const { addFlash, addSuccessFlash } = useFlash();
	const { t } = useTranslation("admin");
	const history = useHistory();

	const onSubmit = handleSubmit(async (data) => {
		setLoading(true);

		try {
			if (props.user?.id) {
				data.id = props.user.id;
				const res = await adminApi.updateAdminUser(data.id, data);
				reset(res);
				addSuccessFlash(t("common.flash.saved", { ns: "lib" }));
			} else {
				const res = await adminApi.createAdminUser(data);
				addSuccessFlash(t("common.flash.saved", { ns: "lib" }));
				history.push(`/admin/users/${res.id}`);
			}
		} catch (e) {
			handleError.form(e, setError, addFlash);
		}
		setLoading(false);
	});

	return (
		<Form key="user-form" noValidate onSubmit={onSubmit}>
			<fieldset className={"form-group no-gutters"}>
				<h5>{t("common.word.basic_data", { ns: "lib" })}</h5>
				<div className="row">
					<div className={"col-md-10"}>
						<FormInput label={t("lib:common.word.name")} register={register} name="name" errors={errors} />
						<FormInput
							label={t("lib:common.word.email")}
							register={register}
							name="email"
							errors={errors}
						/>
					</div>
				</div>
			</fieldset>
			<ButtonLoading loading={loading} type="submit" onClick={onSubmit}>
				{t("common.action.save", { ns: "lib" })}
			</ButtonLoading>
		</Form>
	);
};

export default UserForm;
